import Skeleton from "./Skeleton";
import SkeletonText from "./SkeletonText";

const SkeletonBanner = () => {
  return (
    <div className="bg-gray-60 p-[3rem] min-h-[400px] border border-black/10">
      <div className="flex flex-col md:flex-row items-center gap-6"> 
        <div className="md:w-[60%] w-full order-2 md:order-1 space-y-4">
          <Skeleton className="w-32 h-6" />
          <Skeleton className="w-3/4 h-8" />
          <SkeletonText lines={3} />
          <Skeleton className="w-32 h-10" />
        </div>
 
        <div className="md:w-[40%] w-full order-1 md:order-2">
          <Skeleton className="w-full h-[250px] md:h-[300px] rounded-md" />
        </div>

      </div>
    </div>
  );
};

export default SkeletonBanner;